module.exports = __webpack_public_path__ + "static/media/pink-logo.e76c7f31.png";